// Sanea una URL proveniente de contenido editable: solo permite esquemas seguros para href/src.
// Bloquea javascript:, data:, vbscript:, etc. (evita XSS almacenado si alguien pega una URL maliciosa
// en el panel). Devuelve undefined si la URL no es segura, para que el atributo no se renderice.

const SAFE_PROTOCOLS = ["http:", "https:", "mailto:", "tel:"];

export function safeUrl(raw) {
  if (typeof raw !== "string") return undefined;
  const v = raw.trim();
  if (v === "") return undefined;
  // Rutas internas y anclas son seguras.
  if (v.startsWith("/") || v.startsWith("#")) return v;
  try {
    const parsed = new URL(v, window.location.origin);
    return SAFE_PROTOCOLS.includes(parsed.protocol) ? v : undefined;
  } catch (e) {
    return undefined;
  }
}
